import React from 'react';

import { Box, Text } from '@chakra-ui/react';

import AppTable from 'components/AppTable';

import { PriceSpecificity } from './types';

type PriceByGroupTableProps = {
  data?: PriceSpecificity[];
};

const formatCurrency = (value?: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value ?? 0);
};

const PriceByGroupTable: React.FC<PriceByGroupTableProps> = ({ data = [] }) => {
  return (
    <Box width="100%" mt={8}>
      <Text
        fontWeight="600"
        color="gray.800"
        borderBottom="1px solid"
        borderBottomColor="gray.200"
        pb={2}
        mb={3}
      >
        Preço por grupo de insumo
      </Text>

      <AppTable
        data={data}
        cols={[
          { field: 'key', description: 'Código', sortable: false },
          { field: 'description', description: 'Grupo', sortable: false },
          {
            field: 'total',
            description: 'Preço',
            isNumeric: true,
            sortable: false,
          },
        ]}
        mapping={(item: PriceSpecificity) => ({
          id: item.referenceId,
          key: <Text fontWeight="bold">{item.referenceId || '-'}</Text>,
          description: (
            <Text whiteSpace="pre-wrap" maxW={{ base: '100%', md: '420px' }}>
              {item.description || '-'}
            </Text>
          ),
          total: formatCurrency(item.total),
          actions: null,
        })}
        noDataMessage="Nenhum grupo de insumo cadastrado para este preço."
      />
    </Box>
  );
};

export default PriceByGroupTable;
